import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { InputComponent } from '../../../core/controls/input.component';
import { NotifyOptionComponent } from './notify-option.component';

@Component({
  selector: 'app-days-notify-option',
  imports: [InputComponent, NotifyOptionComponent],
  template: `
    <div class="tw-col-span-2 tw-flex" role="group" [attr.aria-labelledby]="labelId">
      <span class="label tw-grow tw-font-bold tw-pt-2" [id]="labelId">{{ label }}</span>
      <div class="tw-max-w-[150px]">
        <app-input type="Integer" [control]="control" [max]="99999" label="Days"></app-input>
      </div>
    </div>
    <app-notify-option [control]="notifyControl" />
  `,
  styles: ``,
})
export class DaysNotifyOptionComponent implements OnInit {
  protected labelId = 'days-notify-option-' + Math.trunc(Math.random() * 100000);

  @Input()
  control: FormControl<number>;

  @Input()
  notifyControl: FormControl<number>;

  @Input()
  label: string;

  async ngOnInit() {
    this.control.setValidators([
      Validators.required,
      Validators.min(1),
      Validators.max(99999),
    ]);
    if (this.control.value == null) {
      this.control.setValue(30);
    }
    this.control.updateValueAndValidity({ emitEvent: false });

    if (this.notifyControl.value == null) {
      this.notifyControl.setValue(1);
    }
    this.notifyControl.updateValueAndValidity({ emitEvent: false });
  }
}
